<template>
  <div class="myhome-family xs-12 m-8 l-9">
    <div class="myhome-family__title dea-heading--medium-xxl" tabindex="0">
      La mia famiglia
    </div>
    <div class="myhome-family__description">
      <div
        v-if="user.children && user.children.length > 0"
        class="myhome-family__description-label dea-heading--regular-m"
      >
        Qui trovi tutti i dati degli studenti e studentesse che hai aggiunto al tuo profilo Famiglia.
      </div>
      <div v-else class="myhome-family__description-label dea-heading--regular-m">
        Non hai ancora aggiunto studenti o studentesse al tuo profilo Famiglia.
      </div>
      <div class="myhome-family__description-button">
        <Buttons class="dea-button--large" icon="add" @click.stop="toggleStudentModal(true)">Aggiungi studente</Buttons>
      </div>
    </div>
    <UserData
      v-for="(child, idx) in user.children"
      :key="idx"
      :link-color="user.targetCss.colorMod"
      :modify-last-name="true"
      :user="child"
    />
    <StudentModal v-if="modalVisible" :user="user" :visible="modalVisible" @modal-close="toggleStudentModal(false)" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Buttons from "@/components/elements/Buttons";
import UserData from "../components/UserData";
import StudentModal from "~/components/myProfile/modals/StudentModal";
import setFocus from "~/helpers/setFocus";

export default {
  name: "MyProfilFamily",
  components: { Buttons, StudentModal, UserData },
  props: {},
  data() {
    return {
      children: [],
      modalVisible: false,
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  mounted() {
    setFocus("myhome-family__title");
  },
  activated() {
    setFocus("myhome-family__title");
  },
  methods: {
    addStudent() {
      // TODO: add missing implementation?
    },
    toggleStudentModal(open) {
      this.modalVisible = open;
      if (open) {
        document.body.style.overflowY = "hidden";
      } else {
        document.body.style.overflowY = "auto";
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.myhome-family {
  &__title {
    margin-bottom: $space-large;
  }

  &__description {
    @include media("<=m") {
      flex-direction: column;

      &-label {
        margin-bottom: $space-base;
      }
    }

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: $space-large;

    &-button {
      white-space: nowrap;
    }
  }

  .email-field {
    margin-top: 0;
  }
}
</style>
